import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Watergate Gallery</p>
        <h1>Discover Contemporary Art</h1>
        <p className="lede">
          Explore a curated selection of contemporary art from both established and emerging artists. 
          Immerse yourself in creativity and find the perfect piece that resonates with you.
        </p>
        <div className="cta-row">
          <a href="/exhibitions" target="_self">
            View Current Exhibitions
          </a>
          <a href="/artists" target="_self" className="secondary">
            Meet Our Artists
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Engage with Art</h2>
          <p>
            Join us for gallery events and artist talks that deepen your appreciation for contemporary art.
          </p>
        </article>
        <article>
          <h2>Support Emerging Talent</h2>
          <p>
            Discover new voices in the art world and support the next generation of artists through our exhibitions.
          </p>
        </article>
        <article>
          <h2>Curate Your Collection</h2>
          <p>
            Whether you are a seasoned collector or a first-time buyer, our knowledgeable staff is here to help you find the perfect piece.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;